<search-input-with-filters
    [searchControl]="datable.searchControl"
    [pluralName]="pluralName"
    [filters]="filters"
    (filterChange)="onFilterChange($event)"
></search-input-with-filters>
